import { createSlice, useDispatch } from '@oceanjs/core';
import { useCallback } from 'react';
import { useLibrarySelector } from '../internal/hooks/useLibrarySelector';
const initialState = { visible: false };
const mainMenuSlice = createSlice({
    name: 'mainMenu',
    initialState: initialState,
    reducers: {
        setMainMenuVisibile: (state, action) => {
            state.visible = action.payload;
        },
    },
});
export const { setMainMenuVisibile } = mainMenuSlice.actions;
export const mainMenuReducer = mainMenuSlice.reducer;
/**
 * Returns the current visibility state of the main menu
 * @returns True if the main menu is visible
 */
export function useMainMenuVisible() {
    return useLibrarySelector((state) => state.mainMenu.visible);
}
/**
 * Creates a callback to change the visibility of the main menu
 * @returns Callback to change the visibility of the main menu
 */
export function useSetMainMenuVisible() {
    const dispatch = useDispatch();
    return useCallback((visible) => dispatch(setMainMenuVisibile(visible)), [dispatch]);
}
//# sourceMappingURL=mainMenu.js.map